/** A small demo set so the app is usable right after the first start. */
import { parseImport } from './parser';
import { makeSetId } from './ids';
import { FIRST_RUN_KEY, getSets, upsertSet } from './storage';

export const SAMPLE_TEXT = `DE;FR
==Lernziel 01: Zuhause
das Haus;la maison
das Fenster;la fenêtre
die Türe;la porte
der Tisch;la table
das Buch;le livre
==Lernziel 02: Tiere und Essen
der Hund;le chien
die Katze;le chat
der Apfel;la pomme
das Brot;le pain
das Wasser;l'eau
==Lernziel 03: Draussen
die Schule;l'école
der Freund;l'ami
die Stadt;la ville
der Baum;l'arbre
die Blume;la fleur`;

export function seedSampleSetOnce(): void {
  if (localStorage.getItem(FIRST_RUN_KEY)) return;
  localStorage.setItem(FIRST_RUN_KEY, '1');

  if (getSets().length > 0) return;

  const parsed = parseImport(SAMPLE_TEXT);
  const now = Date.now();

  upsertSet({
    id: makeSetId(),
    name: 'Beispiel: Französisch 1',
    nativeLang: parsed.nativeLang,
    foreignLang: parsed.foreignLang,
    createdAt: now,
    updatedAt: now,
    cards: parsed.cards,
  });
}
